<template>
  <div class="map-icon" :style="iconStyle">
    <div class="icon-content">
      <img :src="icon" />
    </div>
  </div>
</template>

<style scoped>

  .map-icon {
    transform: rotate(-45deg);
    transform-origin: 50% 50%;
    border-radius: 50% 50% 50% 0;
    padding: 0 3px 3px 0;
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid white;
    -webkit-box-shadow: -1px 1px 4px rgba(0, 0, 0, .5);
    -moz-box-shadow: -1px 1px 4px rgba(0, 0, 0, .5);
    box-shadow: -1px 1px 4px rgba(0, 0, 0, .5);
  }

  .icon-content {
    margin-top: 4px;
    transform: rotate(45deg);
  }

  .map-icon img {
    width: 20px;
    height: 20px;
  }

</style>

<script>
export default {
  name: 'map-icon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconStyle() {
      return {
        backgroundColor: this.color,
      };
    },
  },
};
</script>
